/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WidgetConfig { 
    enabled: boolean;
    position: WidgetConfig.PositionEnum;
    visibility: WidgetConfig.VisibilityEnum;
    defaultPage: WidgetConfig.DefaultPageEnum;
    /**
     * Plain text; [tier_name], [tier_balance] and [balance] are kept as written.
     */
    guestText: string;
    /**
     * Plain text; [tier_name], [tier_balance] and [balance] are kept as written.
     */
    loggedInText: string;
    /**
     * Hex color, or \"\" to inherit the program colors.
     */
    backgroundColor: string;
    /**
     * Hex color, or \"\" to inherit the program colors.
     */
    foregroundColor: string;
    /**
     * \"\" keeps the current return, otherwise a same-store path starting with \"/\".
     */
    loginRedirectPath: string;
    customCss: string;
    openImmediatelyOnLoad: boolean;
}
export namespace WidgetConfig {
    export const PositionEnum = {
        BottomRight: 'bottom-right',
        BottomLeft: 'bottom-left'
    } as const;
    export type PositionEnum = typeof PositionEnum[keyof typeof PositionEnum];
    export const VisibilityEnum = {
        NotShow: 'not_show',
        ShowAlways: 'show_always',
        ShowLoggedOnly: 'show_logged_only',
        ShowGuestsOnly: 'show_guests_only'
    } as const;
    export type VisibilityEnum = typeof VisibilityEnum[keyof typeof VisibilityEnum];
    export const DefaultPageEnum = {
        Advantages: 'advantages',
        Profile: 'profile',
        Orders: 'orders',
        Coupons: 'coupons',
        Rewards: 'rewards',
        Loyalty: 'loyalty',
        Referrals: 'referrals'
    } as const;
    export type DefaultPageEnum = typeof DefaultPageEnum[keyof typeof DefaultPageEnum];
}


